import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { authSlice } from "./reducers/auth";
import { createLogger } from "redux-logger";
import orgChartReducer from "../modules/Organization/orgChart/store/index";
import layoutReducer from '../constants/layout/store/index';

// Create the initial store
const staticReducers = {
  auth: authSlice.reducer,
  organizationChart: orgChartReducer,
  layoutReducer: layoutReducer,
};

const store = configureStore({
  reducer: staticReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(createLogger()),
});

// Create an object to keep track of injected reducers
const injectedReducers = { ...staticReducers };

// Function to inject a new reducer
export function injectReducer(key, reducer) {
  if (injectedReducers[key]) {
    // Reducer already exists, no need to inject
    return false;
  }

  // Add the reducer to the injectedReducers object
  injectedReducers[key] = reducer;

  // Replace the store's reducer with the new combined reducer
  store.replaceReducer(combineInjectedReducers());
  return true;
}

// Helper function to combine all injected reducers
function combineInjectedReducers() {
  return combineReducers({
    ...injectedReducers,
  });
}

export default store;